export default __webpack_public_path__ + "static/media/unzip-win.95f979f0.webp";